import styled from "styled-components";

export const StyledSupportButton = styled.div`
  z-index: 1001;
  position: fixed;
  bottom: 10px;
  width: 36px;
  height: 36px;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  border-radius: 999px;
  transition: all 0.15s ease 0s;
  color: rgb(177, 182, 198);
  background: rgb(39, 43, 56);
  cursor: pointer;
  user-select: none;
  transform: translateZ(0px);
`;
